import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';

const WhatsAppButton = ({
  phoneNumber = '+92 339 2244330',
  message = 'Hello Prime Business Zone, I am reviewing Prime Mall investment opportunities and would like to request current unit availability and payment terms.'
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const formattedMsg = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneNumber.replace(/[^0-9]/g, '')}?text=${formattedMsg}`;

  return (
    <aside aria-label="WhatsApp Commercial Advisory Desk" className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-50 flex items-center gap-3">
      {/* Tooltip badge for luxury desk feel */}
      <span
        className={`hidden md:inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#070C12]/95 border border-[#B99A5B]/40 text-white text-[11px] font-mono shadow-2xl backdrop-blur-md transition-all duration-300 pointer-events-none ${
          isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2'
        }`}
      >
        <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
        <span>Advisory Desk Online</span>
      </span>

      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="relative bg-[#25D366] text-white p-3.5 sm:p-4 rounded-full shadow-[0_10px_25px_rgba(37,211,102,0.4)] hover:scale-110 active:scale-95 transition-all duration-300 flex items-center justify-center border border-white/30 hover:shadow-[0_0_30px_rgba(37,211,102,0.7)] cursor-pointer group"
        title="Direct Commercial Advisory Desk (+92 339 2244330)"
        aria-label="Connect with Prime Business Zone Commercial Advisory Desk on WhatsApp"
      >
        {/* Active online pulse dot */}
        <span className="absolute top-0 right-0 -mt-0.5 -mr-0.5 flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-300 opacity-75" />
          <span className="relative inline-flex rounded-full h-3 w-3 bg-emerald-200 border border-white" />
        </span>

        <MessageSquare className="w-5 h-5 sm:w-6 sm:h-6 group-hover:rotate-12 transition-transform duration-200" />
      </a>
    </aside>
  );
};

export default WhatsAppButton;
